define.alias("shared/components/shared/ui/social-profile-switcher/list", "settings/components/shared/ui/social-profile-switcher/list");